type ParkkiThemeTypes = {
  colors: {
    [key: string]: string;
  };
  fontSizes: {
    [key: string]: string;
  };
  spacings: {
    [key: string]: string;
  };
  parkStatisticsAttendanceBar: {
    valueColors: {
      0: {
        backgroundColor: string;
      };
      51: {
        backgroundColor: string;
      };
      81: {
        backgroundColor: string;
      };
      91: {
        backgroundColor: string;
      };
    };
    mainColor: string;
    unselectedColor: string;
    unselectedValueColor: string;
  };
  flowAttendanceBar: {
    valueColors: {
      0: {
        backgroundColor: string;
      };
    };
    mainColor: string;
    unselectedColor: string;
    unselectedValueColor: string;
  };
};

const ParkkiTheme: ParkkiThemeTypes = {
  colors: {
    white: "white",
    disabledGrey: "#00000061",
    lightGrey: "#ecebeb",
    darkGrey: "#53575A",
    grey: "#3c6382",
    blue: "#2A384B",
    lightBlue: "#3c6382",
    red: "#E55039",
    flatRed: "#ff7675",
    yellow: "#edc337",
    darkOrange: "#f69745",
    orange: "#ffcd63",
    turquoise: "#2195A4",
    turquoise2: "#60a3bc",
    turquoise3: "#82ccdd",
    lightGreen: "#72CF2A",
    green: "#27AE60",
    darkBlue: "#187293",
  },
  fontSizes: {
    title1: "30px",
    title2: "24px",
    title3: "19px",
    xxlarge: "30px",
    xlarge: "24px",
    large: "19px",
    regular: "17px",
    small: "14px",
    xsmall: "12px",
    xxsmall: "10px",
    macro: "8px",
  },
  spacings: {
    teeny: "4px",
    tiny: "8px",
    xsmall: "12px",
    small: "16px",
    base: "24px",
    large: "32px",
    xLarge: "40px",
    xxLarge: "34px",
    muiDefault: "12px",
  },
  parkStatisticsAttendanceBar: {
    valueColors: {
      0: {
        backgroundColor: "#27AE60",
      },
      51: {
        backgroundColor: "#e8d95a",
      },
      81: {
        backgroundColor: "#edc337",
      },
      91: {
        backgroundColor: "#E55039",
      },
    },
    mainColor: "white",
    unselectedColor: "white",
    unselectedValueColor: "#95a5a6",
  },
  flowAttendanceBar: {
    valueColors: {
      0: {
        backgroundColor: "#27AE60",
      },
    },
    mainColor: "#ff7675",
    unselectedColor: "white",
    unselectedValueColor: "#95a5a6",
  },
};

export default ParkkiTheme;
